// Add your custom JS here.
jQuery(window).scroll(function () {
    if (jQuery(this).scrollTop() > 50) {
        jQuery("header.header-site").addClass("scrolled");
    } else {
        jQuery("header.header-site").removeClass("scrolled");
    }
});

jQuery(document).ready(function ($) { });

jQuery(document).ready(function ($) {
    $('[tabindex="0"]').keydown(function (event) {
        if (event.key === "Enter" || event.key === " ") {
            $(this).click();
        }
    });
});

/*skip content*/
document.addEventListener("DOMContentLoaded", function () {
    const LinkGoSecondSection = document.getElementById("GoSecondSection");
    if (!LinkGoSecondSection) return;
    LinkGoSecondSection.addEventListener("click", function (event) {
        event.preventDefault();
        const secondSection = document.querySelector(
            ".general-section:nth-of-type(2)",
        );
        if (secondSection) {
            secondSection.scrollIntoView({ behavior: "smooth" });
        } else {
            console.error("the second section was not found.");
        }
    });
});

function autosize() {
    var el = this;
    setTimeout(function () {
        el.style.cssText = "height:auto; padding:0";
        // for box-sizing other than "content-box" use:
        // el.style.cssText = '-moz-box-sizing:content-box';
        el.style.cssText = "height:" + (el.scrollHeight + 2) + "px";
    }, 0);
}

// AOS (Animate On Scroll) refresh on AJAX / Search & Filter: results re-rendered need refreshHard or area stays blank
document.addEventListener("DOMContentLoaded", function () {
    if (typeof AOS === "undefined") return;

    var aosFilterDebounce = null;
    function aosAfterSearchFilterUpdate() {
        if (typeof AOS === "undefined") return;
        clearTimeout(aosFilterDebounce);
        aosFilterDebounce = setTimeout(function () {
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    AOS.refreshHard();
                });
            });
        }, 100);
    }

    if (typeof jQuery !== "undefined") {
        jQuery(document).on("sf:ajaxfinish", aosAfterSearchFilterUpdate);
    }

    document
        .querySelectorAll(".block-search-and-filter-events")
        .forEach(function (block) {
            if (typeof MutationObserver === "undefined") return;
            var mo = new MutationObserver(aosAfterSearchFilterUpdate);
            mo.observe(block, { childList: true, subtree: true });
        });

    var target = document.querySelector(".block-search-and-filter-events");
    if (target && typeof ResizeObserver !== "undefined") {
        var resizeTimer = null;
        var ro = new ResizeObserver(function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                if (typeof AOS !== "undefined") AOS.refreshHard();
            }, 150);
        });
        ro.observe(target);
    }
});

//  Smooth scroll for hash links
document.addEventListener("DOMContentLoaded", function () {
    const isMobile = window.innerWidth < 992;
    const offset = isMobile ? 180 : 230;

    function scrollToHash(hash) {
        const el = document.querySelector(hash);
        if (el) {
            setTimeout(() => {
                window.scrollTo({
                    top:
                        el.getBoundingClientRect().top +
                        window.pageYOffset -
                        offset,
                    behavior: "smooth",
                });
            }, 50);
        }
    }

    if (window.location.hash) {
        scrollToHash(window.location.hash);
    }

    document.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.addEventListener("click", function (e) {
            const hash = this.getAttribute("href");
            if (hash.length > 1) {
                e.preventDefault();
                history.pushState(null, null, hash);
                scrollToHash(hash);
            }
        });
    });
});

// Header Buttons in Mega Menu Mobile
document.addEventListener("DOMContentLoaded", function () {
    const headerButtons = document.querySelector(".header-buttons");
    const megaMenu = document.querySelector("#mega-menu-primary");

    const liButtons = document.createElement("li");
    liButtons.className =
        "mega-menu-item mega-menu-item-type-custom mega-align-bottom-left mega-menu-flyout menu-item-header-buttons";

    let isInMegaMenu = false;

    function moveButtonsToMenu() {
        if (window.innerWidth <= 1000 && !isInMegaMenu) {
            if (headerButtons && megaMenu) {
                liButtons.appendChild(headerButtons);
                megaMenu.appendChild(liButtons);
                isInMegaMenu = true;
            }
        } else if (window.innerWidth > 1000 && isInMegaMenu) {
            const originalContainer =
                document.querySelector(".content-elements");
            if (originalContainer && headerButtons) {
                originalContainer.appendChild(headerButtons);
                if (liButtons.parentNode)
                    liButtons.parentNode.removeChild(liButtons);
                isInMegaMenu = false;
            }
        }
    }

    moveButtonsToMenu();
    window.addEventListener("resize", moveButtonsToMenu);
});

// Lenis Smooth Scroll
document.addEventListener("DOMContentLoaded", function () {
    if (typeof Lenis === "undefined") return;

    // Initialize Lenis
    const lenis = new Lenis({
        autoRaf: true,
    });
});

// Button glow effect
jQuery(document).ready(function ($) {
    const isValidColor = (color) => {
        try {
            chroma(color);
            return true;
        } catch {
            return false;
        }
    };

    const normalizeFormSubmitButtons = () => {
        $(
            ".gform_wrapper input[type='submit'], .gform_wrapper button[type='submit']",
        )
            .addClass("btn-site btn-fill")
            .attr("data-btn-theme", "fill");
    };

    const generateGlowButtons = () => {
        normalizeFormSubmitButtons();

        $(
            ".btn-site, .button-link-menu a, button[type='submit'], input[type='submit'], .button-content a",
        ).each(function () {
            const $button = $(this);

            if (
                $button.hasClass("btn-link") ||
                $button.hasClass("btn-outline") ||
                $button.hasClass("btn-arrow")
            ) {
                return;
            }

            $button.off("pointermove").on("pointermove", function (e) {
                const rect = this.getBoundingClientRect();
                const x = e.clientX - rect.left;
                const y = e.clientY - rect.top;

                gsap.to(this, {
                    "--pointer-x": `${x}px`,
                    "--pointer-y": `${y}px`,
                    duration: 0.6,
                });

                const style = getComputedStyle(this);
                const glowStart = style
                    .getPropertyValue("--button-glow-start")
                    .trim();
                const glowEnd = style
                    .getPropertyValue("--button-glow-end")
                    .trim();

                if (isValidColor(glowStart) && isValidColor(glowEnd)) {
                    const mixedColor = chroma
                        .mix(glowStart, glowEnd, x / rect.width)
                        .hex();

                    gsap.to(this, {
                        "--button-glow": mixedColor,
                        duration: 0.2,
                    });
                }
            });
        });
    };

    generateGlowButtons();
    $(window).on("resize", generateGlowButtons);
    $(document).on(
        "gform_post_render gform_confirmation_loaded gform_page_loaded",
        generateGlowButtons,
    );

    setTimeout(() => {
        generateGlowButtons();
    }, 1000);
});

jQuery(document).ready(function ($) {
    $(".button-link-menu a, .button-content a").each(function () {
        const $link = $(this);
        if (!$link.find("span").length) {
            const text = $link.text();
            $link.html(`<span>${text}</span>`);
        }
    });
});

/** 
 * Separator sections effect
*/

document.addEventListener("DOMContentLoaded", () => {

    const sections = [...document.querySelectorAll(".general-section")]
        .map(section => {

            const separator = section.querySelector(".section-separator");
            const path = section.querySelector(".mountainPath");

            if (!separator || !path) return null;

            return {
                section,
                separator,
                path,
                isTop: separator.classList.contains("top"),
                lastHeight: null
            };
        })
        .filter(Boolean);

    if (!sections.length) return;

    function generateMountain(height) {
        return `M925.522 0
        C940.939 0 955.314 ${height * 0.2}
        963.748 ${height * 0.5}
        H964.338
        C972.834 ${height * 0.8}
        986.938 ${height}
        1002.04 ${height}
        H1920.54
        V103.619
        H0
        V0
        H925.522Z`;
    }

    function updateSection(item, viewportH) {

        const rect = item.section.getBoundingClientRect();

        if (rect.bottom < -200 || rect.top > viewportH + 200) return;

        let progress;

        if (item.isTop) {

            if (rect.top > viewportH * 0.3) return;

            progress = Math.min(
                Math.max((viewportH * 0.3 - rect.top) / (viewportH * 0.3), 0),
                1
            );

        } else {

            if (rect.top > viewportH * 0.1) return;

            progress = Math.min(
                Math.max((viewportH * 0.1 - rect.top) / (viewportH * 0.7), 0),
                1
            );
        }

        const height = 40 * (1 - progress);

        if (height === item.lastHeight) return;

        item.lastHeight = height;
        item.path.setAttribute("d", generateMountain(height));
    }

    function update() {

        const viewportH = window.innerHeight;

        sections.forEach(item => updateSection(item, viewportH));
    }

    let ticking = false;

    function requestTick() {
        if (ticking) return;

        ticking = true;

        requestAnimationFrame(() => {
            update();
            ticking = false;
        });
    }

    window.addEventListener("scroll", requestTick, { passive: true });
    window.addEventListener("resize", requestTick);

    update();
});


// Counter Animation for stats
document.addEventListener("DOMContentLoaded", function () {
    const counters = document.querySelectorAll(".js-counter");
    if (counters.length === 0) return;

    // Store the original text of each counter before doing anything
    counters.forEach((el) => {
        el.dataset.originalText = el.innerText.trim();
    });

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                const el = entry.target;
                const originalText = el.dataset.originalText;

                if (entry.isIntersecting) {
                    // Do nothing if already animating or if it finished while still visible
                    if (
                        el.dataset.animating === "true" ||
                        el.dataset.finished === "true"
                    )
                        return;

                    el.dataset.animating = "true";

                    const numericString = originalText.replace(/[^0-9.]/g, "");
                    if (!numericString) return;

                    const targetNumber = parseFloat(numericString);
                    const duration = 2000; // 2 seconds
                    const frameDuration = 1000 / 60;
                    const totalFrames = Math.round(duration / frameDuration);

                    let frame = 0;
                    const easeOutQuad = (t) => t * (2 - t);

                    clearInterval(el.counterInterval);
                    el.counterInterval = setInterval(() => {
                        frame++;
                        const progress = easeOutQuad(frame / totalFrames);
                        const currentCount = Math.round(
                            targetNumber * progress,
                        );
                        const formattedNumber =
                            currentCount.toLocaleString("en-US");

                        el.innerText = originalText.replace(
                            /[0-9.,]+/,
                            formattedNumber,
                        );

                        if (frame >= totalFrames) {
                            clearInterval(el.counterInterval);
                            el.innerText = originalText;
                            el.dataset.animating = "false";
                            el.dataset.finished = "true"; // Mark as finished to prevent replay on small scroll changes
                        }
                    }, frameDuration);
                } else {
                    // When entirely out of viewport
                    clearInterval(el.counterInterval);
                    el.dataset.animating = "false";
                    el.dataset.finished = "false"; // Ready to restart on next scroll
                    // Visually reset it to 0
                    el.innerText = originalText.replace(/[0-9.,]+/, "0");
                }
            });
        },
        { threshold: 0.1 }, // Triggers when at least 10% is visible
    );

    counters.forEach((counter) => observer.observe(counter));
});

// Latest resources Swiper logic
document.addEventListener("DOMContentLoaded", function () {
    if (typeof Swiper === "undefined") return;

    const clearSlideMinHeights = function (slides) {
        slides.forEach(function (slide) {
            slide.style.minHeight = "";
        });
    };

    const getRealSwiperSlides = function (swiper) {
        if (!swiper || !swiper.slides) return [];
        return Array.prototype.slice.call(swiper.slides).filter(function (slide) {
            return !slide.classList.contains("swiper-slide-duplicate");
        });
    };

    const shouldForceFullSlideWidth = function (swiper, isSingle) {
        if (isSingle) return true;
        if (getRealSwiperSlides(swiper).length <= 1) return true;
        return !window.matchMedia("(min-width: 768px)").matches;
    };

    const normalizeSlideWidths = function (swiper, isSingle) {
        if (!swiper || !swiper.slides) return;
        const slides = Array.prototype.slice.call(swiper.slides);

        if (!shouldForceFullSlideWidth(swiper, isSingle)) {
            slides.forEach(function (slide) {
                slide.style.removeProperty("width");
                slide.style.removeProperty("max-width");
            });
            return;
        }

        slides.forEach(function (slide) {
            slide.style.width = "100%";
            slide.style.maxWidth = "100%";
        });
    };

    const shouldEqualizeSwiperSlides = function (swiper) {
        const slides = getRealSwiperSlides(swiper);
        if (slides.length <= 1) return false;
        return window.matchMedia("(min-width: 768px)").matches;
    };

    const equalizeSwiperSlides = function (swiper) {
        if (!swiper || !swiper.slides || !swiper.slides.length) return;
        const slides = Array.prototype.slice.call(swiper.slides);
        clearSlideMinHeights(slides);

        if (!shouldEqualizeSwiperSlides(swiper)) return;

        const realSlides = getRealSwiperSlides(swiper);
        let maxH = 0;
        realSlides.forEach(function (slide) {
            const h = slide.offsetHeight;
            if (h > maxH) maxH = h;
        });
        if (maxH < 1) return;
        realSlides.forEach(function (slide) {
            slide.style.minHeight = maxH + "px";
        });
    };

    const scheduleSlideLayout = function (swiper, isSingle) {
        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                normalizeSlideWidths(swiper, isSingle);
                equalizeSwiperSlides(swiper);
            });
        });
    };

    const initResourcesSwiper = function (
        sliderSelector,
        paginationSelector,
        enableAutoplay = false,
        options = {},
    ) {
        const tabletSlidesPerView =
            typeof options.tabletSlidesPerView === "number"
                ? options.tabletSlidesPerView
                : 2;
        document.querySelectorAll(sliderSelector).forEach(function (sliderEl) {
            if (sliderEl.classList.contains("swiper-initialized")) return;

            const slideCount = sliderEl.querySelectorAll(".swiper-slide").length;
            const isSingle = slideCount <= 1;

            if (isSingle) {
                sliderEl.classList.add("swiper--single-slide");
            }

            const swiperOptions = {
                slidesPerView: 1,
                spaceBetween: isSingle ? 0 : 20,
                loop: !isSingle,
                speed: 600,
                watchOverflow: true,
                on: {
                    init: function () {
                        const self = this;
                        scheduleSlideLayout(self, isSingle);
                        sliderEl
                            .querySelectorAll("img")
                            .forEach(function (img) {
                                if (!img.complete) {
                                    img.addEventListener("load", function () {
                                        scheduleSlideLayout(self, isSingle);
                                    });
                                }
                            });
                    },
                    resize: function () {
                        scheduleSlideLayout(this, isSingle);
                    },
                    slideChangeTransitionEnd: function () {
                        scheduleSlideLayout(this, isSingle);
                    },
                    update: function () {
                        scheduleSlideLayout(this, isSingle);
                    },
                },
            };

            if (isSingle) {
                swiperOptions.allowTouchMove = false;
            } else {
                swiperOptions.breakpoints = {
                    768: {
                        slidesPerView: Math.min(
                            tabletSlidesPerView,
                            slideCount,
                        ),
                        spaceBetween: 20,
                    },
                    992: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                };
                const paginationEl = sliderEl.querySelector(paginationSelector);
                if (paginationEl) {
                    swiperOptions.pagination = {
                        el: paginationEl,
                        clickable: true,
                    };
                }
            }

            if (enableAutoplay) {
                swiperOptions.autoplay = {
                    delay: 4500,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                };
            }

            const sw = new Swiper(sliderEl, swiperOptions);
            window.addEventListener("load", function () {
                scheduleSlideLayout(sw, isSingle);
            });
        });
    };

    initResourcesSwiper(
        ".js-latest-resources-swiper",
        ".js-latest-resources-pagination",
        false,
        { tabletSlidesPerView: 1 },
    );
    initResourcesSwiper(
        ".js-hero-latest-resources-swiper",
        ".js-hero-latest-resources-pagination",
        false,
        { tabletSlidesPerView: 1 },
    );
    initResourcesSwiper(
        ".js-hero-banner-events-swiper",
        ".js-hero-banner-events-pagination",
        true,
        { tabletSlidesPerView: 1 },
    );
});

//tabs postcards
document.addEventListener("DOMContentLoaded", function () {
    const navLinks = document.querySelectorAll(".tabs-postcards__nav-link");
    navLinks.forEach((tab) => {
        tab.addEventListener("click", function (e) {
            tab.scrollIntoView({
                behavior: "smooth",
                inline: "center",
                block: "nearest",
            });
        });
    });
});

// Table of contents smooth scroll
document.addEventListener("DOMContentLoaded", function () {
    document
        .querySelectorAll(".list-content a[href^='#']")
        .forEach(function (link) {
            link.addEventListener("click", function (e) {
                const targetId = this.getAttribute("href").slice(1);
                let target = document.getElementById(targetId);

                if (!target) {
                    const linkText = this.textContent.trim().toLowerCase();

                    target = Array.from(
                        document.querySelectorAll("h1, h2, h3"),
                    ).find(
                        (el) =>
                            el.textContent.trim().toLowerCase() === linkText,
                    );
                }
                if (target) {
                    e.preventDefault();

                    const headerOffset = 110;
                    const elementPosition =
                        target.getBoundingClientRect().top + window.scrollY;
                    const offsetPosition = elementPosition - headerOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth",
                    });
                }
            });
        });
});

// Table of contents ScrollSpy (scroll-based, reliable)
document.addEventListener("DOMContentLoaded", function () {
    const tocLinks = document.querySelectorAll(".list-content a[href^='#']");
    if (tocLinks.length === 0) return;

    const targets = [];
    tocLinks.forEach((link) => {
        const targetId = link.getAttribute("href").slice(1);
        if (!targetId) return;

        let target = document.getElementById(targetId);
        if (!target) {
            const linkText = link.textContent.trim().toLowerCase();
            target = Array.from(document.querySelectorAll("h1, h2, h3")).find(
                (el) => el.textContent.trim().toLowerCase() === linkText,
            );
        }

        if (target) {
            targets.push({ link: link, target: target });
        }
    });

    if (targets.length === 0) return;

    const headerOffset = 130;

    function setActive(index) {
        tocLinks.forEach((link) =>
            link.parentElement.classList.remove("active"),
        );
        if (index >= 0 && index < targets.length) {
            targets[index].link.parentElement.classList.add("active");
        }
    }

    function getActiveIndex() {
        const scrollY = window.scrollY;
        let activeIndex = 0;
        for (let i = 0; i < targets.length; i++) {
            const rect = targets[i].target.getBoundingClientRect();
            const absoluteTop = rect.top + scrollY;
            if (absoluteTop - headerOffset <= scrollY) {
                activeIndex = i;
            }
        }
        return activeIndex;
    }

    // Set correct active on page load (handles refresh mid-page & hash)
    setTimeout(() => {
        setActive(getActiveIndex());
    }, 100);

    // Update active on scroll
    window.addEventListener(
        "scroll",
        function () {
            setActive(getActiveIndex());
        },
        { passive: true },
    );
});

// Numbered content side image responsive fit
document.addEventListener("DOMContentLoaded", function () {
    function resetImageStyles(image, filterLayer, wrap) {
        [image, filterLayer].forEach((el) => {
            if (!el) return;
            el.style.position = "";
            el.style.top = "";
            el.style.left = "";
            el.style.right = "";
            el.style.width = "";
            el.style.maxWidth = "";
            el.style.marginLeft = "";
            el.style.marginRight = "";
            el.style.height = "";
            el.style.maxHeight = "";
        });
        wrap.style.minHeight = "";
    }

    function applyNumberedImageLayout() {
        const sections = document.querySelectorAll(".block-numbered-content");
        if (!sections.length) return;

        const vw = window.innerWidth;

        sections.forEach((section) => {
            const image = section.querySelector(
                ".block-numbered-content__image",
            );
            const filterLayer = section.querySelector(
                ".block-numbered-content__image-filter",
            );
            const wrap = section.querySelector(
                ".block-numbered-content__image-wrap",
            );
            const content = section.querySelector(
                ".block-numbered-content__content",
            );
            const contentCol = section.querySelector(
                ".block-numbered-content__content-col",
            );
            if (!image || !wrap) return;

            resetImageStyles(image, filterLayer, wrap);

            if (vw < 992) return;

            const isReverse = section.classList.contains(
                "block-numbered-content--reverse",
            );
            const wrapRect = wrap.getBoundingClientRect();
            const contentRect = contentCol
                ? contentCol.getBoundingClientRect()
                : null;
            const fixedGap = 73;
            const extraOverflow = 24;
            const minImageWidth = 360;

            [image, filterLayer].forEach((el) => {
                if (!el) return;
                el.style.position = "absolute";
                el.style.top = vw >= 1250 ? "0" : "15%";
            });

            if (contentRect) {
                if (isReverse) {
                    const desiredLeftViewport = contentRect.right + fixedGap;
                    const desiredRightViewport = vw + extraOverflow;
                    const width = Math.max(
                        minImageWidth,
                        Math.round(desiredRightViewport - desiredLeftViewport),
                    );
                    const left = Math.round(
                        desiredLeftViewport - wrapRect.left,
                    );

                    [image, filterLayer].forEach((el) => {
                        if (!el) return;
                        el.style.left = `${left}px`;
                        el.style.right = "auto";
                        el.style.width = `${width}px`;
                        el.style.maxWidth = `${width}px`;
                    });
                } else {
                    const desiredLeftViewport = -extraOverflow;
                    const desiredRightViewport = contentRect.left - fixedGap;
                    const width = Math.max(
                        minImageWidth,
                        Math.round(desiredRightViewport - desiredLeftViewport),
                    );
                    const left = Math.round(
                        desiredLeftViewport - wrapRect.left,
                    );

                    [image, filterLayer].forEach((el) => {
                        if (!el) return;
                        el.style.left = `${left}px`;
                        el.style.right = "auto";
                        el.style.width = `${width}px`;
                        el.style.maxWidth = `${width}px`;
                    });
                }
            }

            if (content) {
                const contentHeight = content.offsetHeight;
                const fittedHeight = Math.min(contentHeight || 0, 456);
                if (fittedHeight > 0) {
                    [image, filterLayer].forEach((el) => {
                        if (!el) return;
                        el.style.height = `${fittedHeight}px`;
                        el.style.maxHeight = `${fittedHeight}px`;
                    });
                    wrap.style.minHeight = `${fittedHeight}px`;
                }
            }
        });
    }

    const run = () => requestAnimationFrame(applyNumberedImageLayout);
    run();
    window.addEventListener("load", run);
    window.addEventListener("resize", run);
});

// CTA side form: keep video aligned behind text column on desktop
document.addEventListener("DOMContentLoaded", function () {
    const desktopMin = 992;

    function alignCtaSideFormVideo() {
        const blocks = document.querySelectorAll(".cta-side-form");

        blocks.forEach((block) => {
            const videoContainer = block.querySelector(":scope > .video-container");
            const textColumn = block.querySelector(".cta-side-form__col-text");
            const titleContent = block.querySelector(".title-content");

            if (!videoContainer || !textColumn) return;

            if (window.innerWidth < desktopMin) {
                videoContainer.style.removeProperty("left");
                videoContainer.style.removeProperty("top");
                videoContainer.style.removeProperty("width");
                videoContainer.style.removeProperty("height");
                videoContainer.style.removeProperty("transform");
                return;
            }

            const blockRect = block.getBoundingClientRect();
            const textRect = textColumn.getBoundingClientRect();
            const anchorRect = titleContent
                ? titleContent.getBoundingClientRect()
                : textRect;

            const videoWidth = Math.min(blockRect.width * 0.5533, 760);
            const vw = window.innerWidth;
            const responsiveOffset = Math.round(
                250 + Math.max(0, (vw - 992) * 0.03),
            );
            const left =
                textRect.left -
                blockRect.left -
                videoWidth * 0.12 -
                responsiveOffset;
            const top = -45;
            const minLeftBound = -Math.round(videoWidth * 0.45);
            const boundedLeft = vw <= 1350 ? Math.max(left, minLeftBound) : left;

            videoContainer.style.left = `${Math.round(boundedLeft)}px`;
            videoContainer.style.top = `${Math.round(top)}px`;
            videoContainer.style.width = `${Math.round(videoWidth)}px`;
            videoContainer.style.height = "100%";
            videoContainer.style.transform = "none";
        });
    }

    const run = () => requestAnimationFrame(alignCtaSideFormVideo);
    run();
    window.addEventListener("load", run);
    window.addEventListener("resize", run);
});
